export const appsCatalogFilteredSetItemsDatatable = "/apps/catalog_filtered_set_items_datatable";
